import { Element } from '../types/types';

const sanitizeForClassName = (value: string) => value.replace(/[^a-zA-Z0-9_-]/g, '-');

const toSlug = (value: string) => sanitizeForClassName(value.trim().toLowerCase());

export const createStableElementClass = (elementType: string, stableId?: string | number): string => {
  const idToken = stableId !== undefined && stableId !== null && String(stableId).trim() !== ''
    ? toSlug(String(stableId))
    : `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

  return `pb-element-${toSlug(elementType)}-${idToken}`;
};

export const getElementClassFromProperties = (element: Element, fallbackId?: string): string => {
  const props = element.properties || {};
  const persistedClass =
    props.elementClass ||
    props.className ||
    props.htmlConfig?.attributes?.class ||
    props.htmlConfig?.attributes?.className;

  if (typeof persistedClass === 'string' && persistedClass.trim()) {
    return persistedClass.trim();
  }

  return createStableElementClass(element.type, fallbackId || element.id);
};

export const createRuntimeElementId = (elementType: string): string => {
  return `${elementType}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
};
